import {ReactNode} from "react";

export const StatusMessage = ({ children }: { children: ReactNode }) => (
  <h1 className={"mb-5 text-center"}>{children}</h1>
);
